module.exports = __webpack_public_path__ + "img/5-threeImg.a47ff9c1.png";